<template>
    <!-- 费用管理  -->
    <sub-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg"
        :right-bg="rightBg" :partition="[8, 4]" bottom="-10px" direction="flex-end" :rbgStyle="{ width: '80%' }" />
</template>

<script>
import SubPage from "./components/SubPage.vue";
export default {
    name: 'networkPage',
    components: {
        SubPage
    },
    data() {
        return {
            rightBg: "/img/pay/0--53.png",
            bg: "/img/pay/0-_BG-3.png",
        }
    },
    computed: {
        title() {
            return this.$t('network.title');
        },
        subtitle() {
            return this.$t('networkPage.subtitle');
        },
        description() {
            const desc = this.$t('networkPage.description');
            return Array.isArray(desc) ? desc : [desc];
        },
        buttonText() {
            return this.$t('common.buttonText');
        },
    }
}
</script>
